const booking = {
  bookingInformation: "Información de la reserva", // translated
  ourCancellationPolicy: "Nuestra política de cancelación", // translated
  thisAupersedesAnyCancellationPolicyInRemarksAbove: "Esto reemplaza cualquier política de cancelación en los comentarios anteriores", // translated
  thisBookingIsNonNefundable: "Esta reserva no es reembolsable", // translated
  paymentTerms: "Términos de pago", // translated
  paymentWillBeTakenFromYourDefault: "El pago se tomará de su valor predeterminado", // translated
  paymentMethod: "método de pago", // translated
  afterTheFreeCancellationPeriodIfApplicable: "después del período de cancelación gratuita si corresponde", // translated
  prebook: "Reservar de antemano", // translated
  guests: "Huéspedes", // translated
  payment: "Pago", // translated
  byClicking: "Haciendo click", // translated
  youAreAgreeingToOur: "usted está de acuerdo con nuestro", // translated
  termsAndConditions: "Términos y condiciones", // translated
  lastBookableDate: "Última fecha de reserva", // translated
  customerRemarksTextfield: "Comentarios del cliente", // translated
  request: "Petición", // translated
};


export default booking;
